




























import { QualityGoalType } from '@/interfaces/types/QualityGoal';
import DeleteButton from '@/components/common/Button/DeleteButton.vue';
import Vue, { PropType } from 'vue';

import { deleteQualityGoal } from '@/utils/axiosInstances';
import { showUnsupportedMessage } from '@/utils/demoUtils';

export default Vue.extend({
  components: { DeleteButton },
  props: {
    goalList: {
      type: Array as PropType<Array<QualityGoalType>>,
    },
  },
  data(): {
    list: QualityGoalType[];
    headers: string[];
  } {
    return {
      list: this.goalList,
      headers: ['이름', '설명', '삭제'],
    };
  },
  methods: {
    async deleteItem(idx: number) {
      showUnsupportedMessage(this.$toast);

      // if (confirm('품질 목표를 삭제합니다.')) {
      //   const result = await deleteQualityGoal(
      //     this.goalList[idx].qualityGoalId ?? '',
      //   );

      //   if (result !== 200) {
      //     alert('삭제 중 오류가 발생했습니다.');
      //   } else {
      //     this.list.splice(idx, 1);
      //     this.$emit('update:goalList', this.list);
      //   }
      // }
    },
    clickRow(idx: number) {
      this.$emit('select', idx);
    },
  },
});
